export default {
    plans: {},
    product: {},
    prefillData: {},
    planSelected: false,
    activePlan: {},
    descriptorText: 'Dating Lions GMBH AUSTRIA',
    paymentLocked: false,
    paymentLockedError: '',
    skipMobileSummary: false,
};